import "./stores.css";

const Stores = () => {
    return (
        <div>
            <div className="store-background">
                <p>Our Stores !!!</p>
            </div>
            {/* Jaipur Store */}
            <div className="store">
                <div className="store-info">
                <h3>Pandey Arts Shop</h3>
                <p>
                    Hno 2161, Pandey Arts India, 2nd cross, Kajane walo ka rasta, 
                    Chandpole bajar, Jaipur, Rajasthan 302001
                </p>
                <p className="store-phone">+91 8905046144</p>
                <p>Monday to Sunday | 10 am - 8 pm</p>
                </div>
                <div className="store-map">
                    <iframe
                        title="Shri Hari Om Moorti Bhandar"
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3562.1257612963733!2d75.81266207504172!3d26.923385776657083!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x396c4b20b944839f%3A0xc8fe880c2dcecf71!2sShri%20Hari%20Om%20Moorti%20Bhandar%2C%20Jaipur!5e0!3m2!1sen!2sin!4v1727209500000!5m2!1sen!2sin"
                        width="100%"
                        height="250"
                        style={{ border: 0 }}
                        allowFullScreen=""
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                    ></iframe>
                </div>
            </div>

            {/* Kishangarh Store */}
            <div className="store">
                <div className="store-info">
                <h3>Pandey Arts Warehouse</h3>
                <p>
                    Hno 2161, Pandey Arts India, 2nd cross, Kajane walo ka rasta, 
                    Chandpole bajar, Jaipur, Rajasthan 302001
                </p>
                <p className="store-phone">+91 78916 76144</p>
                <p>Monday to Sunday | 10 am - 8 pm</p>
                </div>
                <div className="store-map">
                    <iframe
                        title="Shri Hari Om Moorti Bhandar"
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3562.1257612963733!2d75.81266207504172!3d26.923385776657083!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x396c4b20b944839f%3A0xc8fe880c2dcecf71!2sShri%20Hari%20Om%20Moorti%20Bhandar%2C%20Jaipur!5e0!3m2!1sen!2sin!4v1727209500000!5m2!1sen!2sin"
                        width="100%"
                        height="250"
                        style={{ border: 0 }}
                        allowFullScreen=""
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                    ></iframe>
                </div>
            </div>
        </div>
    );
}

export default Stores;